<div class="container">
    <!-- Header -->
    <div class="header">
        <div class="row">
            <div class="col">
                <h4>
                    <i class="bi bi-arrow-repeat"></i>
                    Remaining Sync Data
                </h4>
                <div class="header-subtitle">
                    Manage device synchronization and data transfer processes
                </div>
            </div>
            <div class="col-3">
                <ng-select name="DeviceSerialNo" [items]="DeviceData" bindLabel="serial_num" bindValue="serial_num"
                    [(ngModel)]="this.deviceConfig.requestBody.DeviceSerialNo" placeholder="DeviceSerial No"
                    (change)="GetDeviceDetail()">
                </ng-select>
            </div>
        </div>
    </div>

    <div class="content-grid">
        <!-- Device to Device DB Section -->
        <div class="sync-section">
            <div class="section-header">
                <div class="section-icon">
                    <i class="bi bi-database-fill-check"></i>
                </div>
                <div>
                    <div class="section-title">Device to Device DB</div>
                    <div class="section-subtitle">Sync data between physical devices</div>
                </div>
            </div>

            <div class="sync-options">
                <div class="sync-option">
                    <div class="option-header">
                        <div class="option-title">Sync Device</div>
                    </div>
                    <div class="option-description">
                        Synchronize data from physical device to local device database.
                        This process transfers attendance logs, employee data, and device configurations.
                    </div>
                    <div class="action-buttons">
                        <button type="button" class="btn btn-primary" id="syncDeviceBtn" (click)="DeviceToDeviceDB()">
                            <i class="bi bi-arrow-repeat"></i>
                            Start Sync
                        </button>
                    </div>
                    <div class="sync-status info" id="deviceSyncStatus">
                        <div class="row">
                            <div class="col-md-5">
                                Requested On :
                            </div>
                            <div class="col">
                                {{this.filter.DeviceToDBRequest}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                Executed On :
                            </div>
                            <div class="col">
                                {{this.filter.DeviceToDBExecute}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Device DB to Client DB Section -->
        <div class="sync-section">
            <div class="section-header">
                <div class="section-icon">
                    <i class="bi bi-database-fill-up"></i>
                </div>
                <div>
                    <div class="section-title">Device DB to Client DB</div>
                    <div class="section-subtitle">Transfer data to central database</div>
                </div>
            </div>

            <div class="sync-options">
                <div class="sync-option">
                    <div class="filter-row">
                        <div class="filter-group" style="width:175px">
                            <label class="date-label"><i class="bi bi-calendar4-event"></i> From Date</label>
                            <div class="input-group">
                                <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                                    [(ngModel)]="filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                                    readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" style="min-width:10px"
                                    (click)="FromDateObj.toggle()" type="button"></button>
                            </div>
                            <div class="invalid-feedback">
                                Please select from date!
                            </div>
                        </div>
                        <div class="filter-group" style="width:175px">
                            <label class="date-label"><i class="bi bi-calendar4-event"></i> To Date</label>
                            <div class="input-group">
                                <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                                    [(ngModel)]="filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required
                                    readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" style="min-width:10px"
                                    (click)="ToDateObj.toggle()" type="button"></button>
                            </div>
                            <div class="invalid-feedback">
                                Please select to date!
                            </div>
                        </div>
                    </div>
                    <button type="button" class="btn btn-secondary" id="syncAttendanceBtn" (click)="DeviceDBToEss()">
                        <i class="bi bi-check-all"></i>
                        Sync Attendance
                    </button>
                    <div class="sync-status success" id="clientSyncStatus">
                        <div class="row">
                            <div class="col-md-5">
                                Requested On :
                            </div>
                            <div class="col">
                                {{this.filter.DeviceDBToEssRequest}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                Executed On :
                            </div>
                            <div class="col">
                                {{this.filter.DeviceDBToEssExecute}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Distance Section -->
            <!-- <div class="distance-section">
                <div class="distance-header">
                    <i class="fas fa-ruler-combined"></i>
                    Distance
                </div>
                <select class="distance-select" id="distanceSelect">
                    <option value="" disabled selected>Select Distance</option>
                    <option value="10">10 meters</option>
                    <option value="20">20 meters</option>
                    <option value="30">30 meters</option>
                    <option value="50">50 meters</option>
                    <option value="100">100 meters</option>
                    <option value="custom">Custom Distance</option>
                </select>
            </div> -->
        </div>
    </div>

    <div class="divider">
        <div class="divider-text">Device Management Actions</div>
    </div>

    <div class="actions-section">
        <div class="section-header">
            <div class="section-icon" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);">
                <i class="bi bi-gear-fill"></i>
            </div>
            <div>
                <div class="section-title">Device Actions</div>
                <div class="section-subtitle">Manage device operations and settings</div>
            </div>
        </div>

        <div class="actions-grid">
            <!-- Restart Device -->
            <div class="action-card">
                <div class="action-title">
                    <i class="bi bi-power"></i>
                    Restart the Device
                </div>
                <div class="action-description">
                    Safely restart the biometric device. This will temporarily interrupt attendance recording until the
                    device reboots.
                </div>
                <button type="button" class="action-btn warning" (click)="Restart()">
                    <i class="bi bi-arrow-clockwise"></i>
                    Restart
                </button>
                <div class="sync-status info">
                    <div class="row">
                        <div class="col-md-5">
                            Requested On :
                        </div>
                        <div class="col">
                            {{this.filter.LastRestartRequest}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5">
                            Executed On :
                        </div>
                        <div class="col">
                            {{this.filter.LastRestartExecute}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Set Date Time -->
            <div class="action-card">
                <div class="action-title">
                    <i class="bi bi-clock"></i>
                    Set Date & Time
                </div>
                <div class="action-description">
                    Synchronize device date and time with server time. Ensures accurate timestamp for all attendance
                    records.
                </div>
                <button type="button" class="action-btn" (click)="SetDateTime()">
                    <i class="bi bi-clock-fill"></i>
                    Set Time
                </button>
            </div>
        </div>
    </div>
    <div class="bottom-action-bar">
        <div class="device-info-card"
            [ngClass]="{'device-info-card-on':this.filter.status == 1,'device-info-card-off':this.filter.status == 0}"
            style="width:max-content">
            <div class="device-icon">
                <i class="bi bi-person-bounding-box"></i>
            </div>
            <div class="device-details">
                <h3>{{this.deviceConfig.requestBody.DeviceSerialNo}} | <i class="bi"
                        [ngClass]="{'bi-wifi':this.filter.status == 1,'bi-wifi-off':this.filter.status == 0}"></i>
                    {{this.filter.status == 0 ?'Offline':'Online'}}</h3>
            </div>
        </div>
        <div class="cancel-back-buttons">
            <button type="button" class="back-btn-bottom"
                [routerLink]="['/attendancedevice/device/deviceattendance/'+this.deviceConfig.requestBody.DeviceSerialNo]">
                <i class="bi bi-people-fill me-1"></i> Attendance
            </button>
            <button type="button" class="back-btn-bottom"
                [routerLink]="['/attendancedevice/device/deviceemployee/'+this.deviceConfig.requestBody.DeviceSerialNo]">
                <i class="bi bi-person-lines-fill me-1"></i> Employeee
            </button>

            <button type="button" class="back-btn-bottom" id="backBtn" [routerLink]="['/attendancedevice/device']">
                <i class="fas bi bi-arrow-left"></i>
                Back
            </button>
        </div>
    </div>
</div>